import { Button, Icons, Intent, Size } from "construct-ui";
import ViewBase from "../../../view-base.view";
import { MIME_TYPES_AND_FILE_EXTENSION } from "../../../../config/constants";
import userModel from "../../../../models/user/user.model";

export default function UserBatchRegisterComponent() {

  ViewBase.call(this);

  let _acceptableFileTypes = ['.xlsx'];
  let _isInValid = false;
  let _message = "";
  let fileFormData = null;
  let onChange = (e) => { };
  let selectedList = [];

  let downloadTemplate = () => {
    this.showLoading();
    userModel.downloadTemplateExcelForBatchRegistration().catch(error => {
      this.handleError(error);
    }).finally(() => {
      this.hideLoading();
    })
  }

  let _uploadExcelTemplate = () => {
    if (fileFormData != null) {
      _isInValid = false;
      _message = "";
      this.showLoading();
      userModel.uploadExcelForBatchRegistration(fileFormData).then(data => {
        this.showMessage(this.getText("EM00000358", "Please check the downloaded excel for the status"), this.getText("EM00000004", "Success"));
      }).catch(error => {
        this.handleError(error);
      }).finally(() => {
        fileFormData=null;
        document.getElementById('registerForm').reset();
        this.hideLoading();
      })
    } else {
      _isInValid = true;
      _message = this.getText("EM00000316", "Please select a file");
    }
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onChange) {
        onChange = vnode.attrs.onChange;
      }
      if (vnode.attrs.selectedItemList) {
        selectedList = vnode.attrs.selectedItemList;
      }
    },
    onupdate: (vnode) => {
      if (vnode.attrs.selectedItemList) {
        selectedList = vnode.attrs.selectedItemList;
      }
    },
    view: (vnode) => {
      return [
        // Download template
        m('.card.mb-3',
          m('.card-body',
          m('form#registerForm',
            m('.row.g-4.align-items-end',
              m('.col-md-7',
                m('label.form-label.d-block', '1. ', this.getText("LT00000218", "Download Template")),
                m(Button, {
                  class: 'ms-3',
                  iconLeft: Icons.DOWNLOAD,
                  intent: Intent.PRIMARY,
                  label: this.getText("LT00000220", "Excel Template"),
                  size: Size.SM,
                  onclick: () => { downloadTemplate() }
                })
              ),
              m('.col-md-7',
                m('label.form-label', '2. ', this.getText("LT00000197", "Excel Upload")),
                m('.d-flex.gap-2',
                  m('.flex-grow-1.ps-3',
                    m('input#file-upload.form-control[type=file][required]', {
                      onchange: (e) => {
                        let _fileTypeItem = MIME_TYPES_AND_FILE_EXTENSION.find(item => item.mimeType == e.target.files[0].type);

                        if (typeof _fileTypeItem !== 'undefined' && _acceptableFileTypes.indexOf(_fileTypeItem.extension) >= 0) {
                          fileFormData = new FormData();
                          fileFormData.append('file', e.target.files[0]);
                          _isInValid = false;
                          _message = "";
                        }
                        else {
                          _isInValid = true;
                          _message = this.getText("EM00000082", "Invalid file. Cannot process.");
                        }
                      }
                    }),
                  ),
                  m('.flex-shrink-0',
                    m(Button, {
                      label: this.getText("LT00000290", "Upload"),
                      intent: Intent.PRIMARY,
                      onclick: (e) => {
                        _uploadExcelTemplate();
                      }
                    }),
                  ),
                ),
                _isInValid && m('.d-flex.gap-2.ps-3',
                  m(
                    '.invalid-feedback.d-block', _message
                  )
                )
              )

            )
          )
          )
        )
        , this.getBaseViews()
      ]
    }
  }
}
